import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { useTrainingStore } from '../stores/useTrainingStore';

type TimerContextType = {
  timer: number;
  isRunning: boolean;
};

export const TimerContext = createContext<TimerContextType | undefined>(undefined);

export const TimerProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const startedAt = useTrainingStore(state => state.startedAt);
  const sessionId = useTrainingStore(state => state.sessionId);
  const isRunning = Boolean(sessionId && startedAt);
  const [timer, setTimer] = useState(0);

  useEffect(() => {
    if (!startedAt || !isRunning) {
      setTimer(0);
      return;
    }

    const updateTimer = () => {
      setTimer(Math.max(0, Math.floor((Date.now() - startedAt) / 1000)));
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [startedAt, isRunning]);

  return (
    <TimerContext.Provider value={{ timer, isRunning }}>
      {children}
    </TimerContext.Provider>
  );
};

export const useTimer = (): TimerContextType => {
  const context = useContext(TimerContext);
  if (!context) throw new Error('useTimer must be used within a TimerProvider');
  return context;
};
